import { FC, FunctionComponent, useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./AuthLayout.scss";
import SplashScreen from "../../pages/SplashScreen/SplashScreen";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"
import { useAppSelector } from "../../redux/app/hooks";
import { useLocation } from "react-router-dom";
import VirtualClassHeader from "../../components/VirtualClassHeader/VirtualClassHeader";

interface ProType {
  component: FunctionComponent;
}

const AuthLayout: FC<ProType> = ({ component: Component }) => {
  const [splash, setSplash] = useState(true);
  const isSplashVisible = useAppSelector((state) => state.auth.isSplashVisible);
  const [isscroll, setIsscroll] = useState(false);
  const isKaton = useAppSelector((state) => state.auth.isKaton);
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const isKatonParam = params.get('isKaton');

  useEffect(() => {
    setTimeout(() => {
      setSplash(false);
    }, 2000);
  }, []);


  useEffect(() => {
    if (location.pathname === "/legal" || location.pathname === '/faq') {
      setIsscroll(true)
    }else {
      setIsscroll(false)
    }
  }, [location.pathname]);


  return (
    <>
      {splash && isSplashVisible ? (
        <SplashScreen />
      ) : (
        <div className="landingPageContainer" style={{justifyContent: isscroll? 'unset' : 'space-between', overflowY: isscroll? 'auto': undefined}}>
          {((isKaton === "virtualSchool" || isKatonParam === "virtualSchool" || !window?.electron?.isElectron()) && location?.pathname === '/') ? <VirtualClassHeader /> :  <Header /> }
          <Component />
          <Footer />
        </div>
      )}
      <ToastContainer 
            position="top-center"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            />
    </>
  );
};
export default AuthLayout;